export const navigateChecker = (languageCodeData, siteTheme, slug) => {
  const baseURL = process.env.REACT_APP_Baseurl_Frontend;
  const shouldTranslate = siteTheme?.translate_checkout === 1;

  const videoPath = shouldTranslate && languageCodeData
      ? `${baseURL}/${languageCodeData}/${slug}`
      : `${baseURL}/${slug}`;

  return videoPath;
};